<template>
  <b-modal
    id="create-news-modal"
    title="Đăng tải bài viết mới"
    size="xl"
    centered
    hide-footer
    modal-class="flower-modal-decorated"
    title-class="flower-title-decorated"
  >
    <ValidationObserver
      v-if="!isSubmittedSuccess"
      v-slot="{ invalid, handleSubmit }"
    >
      <form @submit.prevent="handleSubmit(handlePost)" ref="formContainer">
        <!-- 1. Tên người đăng (nameAuthor) -->
        <div class="row">
          <div class="col-12 mb-3">
            <ValidationProvider
              :rules="tinTucValidator.rules.nameAuthor"
              name="Tên tác giả"
              v-slot="{ errors }"
            >
              <label class="form-label text-left"
                >Tên của bạn<span class="required-star">&nbsp;*</span></label
              >
              <input
                v-model="form.nameAuthor"
                class="form-control flower-input"
                placeholder="Ví dụ: Nguyễn Văn A"
                :class="{ 'is-invalid': errors[0] }"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </ValidationProvider>
          </div>

          <div class="col-md-12 mb-3">
            <div class="mb-2">
              <ValidationProvider
                :rules="tinTucValidator.rules.describe"
                name="Nội dung"
                v-slot="{ errors }"
              >
                <label class="form-label text-left">Nội dung</label>
                <span class="required-star"
                  >&nbsp;(Tối đa {{ maxDescribeLength }} ký tự)*</span
                >
                <span class="fw-bold ms-2 text-muted character-count">
                  ({{ describeCharacterCount }}/{{ maxDescribeLength }} ký tự)
                </span>
                <textarea
                  v-model="form.describe"
                  id="percent"
                  rows="4"
                  type="text"
                  class="form-control flower-input"
                  placeholder="Nhập nội dung bài viết"
                >
                </textarea>
                <small class="text-danger">{{ errors[0] }}</small>
              </ValidationProvider>
            </div>
          </div>

          <!-- 3. Ảnh liên quan (fileImage) -->
          <div class="col-12 mb-0">
            <div class="mb-2">
              <ValidationProvider
                ref="providerFileImage"
                name="Ảnh bài viết"
                :rules="tinTucValidator.rules.fileImage"
                v-slot="{ errors }"
              >
                <label class="form-label text-left">
                  Ảnh bài viết (600px * 400px)<span class="required-star"
                    >&nbsp;*</span
                  >
                </label>
                <p
                  class="text-muted small mt-1 mb-2"
                  style="color: var(--color-blue-sky) !important"
                >
                  *Tỉ lệ khuyến nghị: 3:2 (Ngang)
                </p>

                <!-- KHU VỰC HIỂN THỊ FILE IMAGE CROPPING (ĐÃ GỘP LOGIC CON) -->

                <div class="file-cropper-area">
                  <!-- Input file ẩn (được kích hoạt bởi nút @click) -->
                  <input
                    type="file"
                    ref="fileUploader"
                    style="display: none"
                    @change="handleFileChange"
                    accept="image/*"
                  />

                  <!-- Khu vực hiển thị file hiện tại (preview) -->
                  <div
                    v-if="form.fileImage?.fileId"
                    class="image-preview-container"
                  >
                    <!-- Ảnh preview chính -->
                    <img
                      :src="url + form.fileImage.fileId"
                      alt="Ảnh bài viết"
                      class="current-file-image"
                      @click="triggerFileUpload"
                    />

                    <!-- Nút Xóa Ảnh (chỉ hiển thị khi có ảnh) -->
                    <button
                      type="button"
                      class="btn-delete-file d-flex justify-content-center align-items-center"
                      @click.stop="
                        deleteFileOnServer(form.fileImage.fileId, true)
                      "
                    >
                      <i class="fas fa-trash-alt"></i>
                    </button>
                  </div>

                  <!-- Nút chọn ảnh ban đầu -->
                  <button
                    v-else
                    type="button"
                    class="btn-select-file"
                    @click="triggerFileUpload"
                  >
                    <i class="fas fa-plus me-1"></i> Chọn/Tải lên ảnh (Tỉ lệ
                    3:2)
                  </button>

                  <!-- LOADING HÌNH ẢNH SAU KHI CẮT -->
                  <div
                    v-if="isUploadingFile"
                    class="uploading-spinner text-primary mt-2"
                  >
                    <i class="fas fa-spinner fa-spin me-2"></i> Đang tải lên...
                  </div>
                </div>

                <small class="text-danger mt-2 d-block">{{ errors[0] }}</small>
              </ValidationProvider>
            </div>
          </div>
        </div>

        <!-- FOOTER NÚT HÀNH ĐỘNG -->
        <div
          class="d-flex justify-content-end pt-2 border-top mt-4 flower-footer-actions"
        >
          <!-- Nút Đóng -->
          <ButtonCore
            text="Đóng"
            variantClass="btn-close-core"
            iconClass="fas fa-times"
            :handleClick="() => closeModal()"
            :customStyle="{ margin: '0 5px' }"
            modalTarget="modal-close_visit"
            :isDisable="isDisableButton || isSubmitting || isUploadingFile"
          />

          <!-- Nút Đăng -->
          <ButtonCore
            :text="isSubmitting ? 'Đang đăng...' : 'Đăng bài'"
            variantClass="btn-accept-core"
            iconClass="fas fa-paper-plane"
            :handleClick="() => handleSubmit(handlePost)"
            modalTarget="modal-close_visit"
            :isDisable="
              invalid || isSubmitting || isDisableButton || isUploadingFile
            "
          />
        </div>
      </form>
      <!-- NEW: THÔNG BÁO CHỜ DUYỆT (Hiển thị khi đăng thành công) -->
      <b-alert
        :show="isSubmittedSuccess"
        variant="success"
        fade
        class="mb-4 flower-alert"
      >
        <h4 class="alert-heading">Bài viết đã được gửi thành công!</h4>
        <p class="mb-0">
          Cảm ơn bạn đã đóng góp nội dung. Bài viết sẽ được quản trị viên kiểm
          duyệt và đăng tải sớm nhất. Vui lòng chờ đợi!
        </p>
      </b-alert>
    </ValidationObserver>
    <div
      v-else
      class="success-result-wrapper text-center py-4 animate__animated animate__fadeIn"
    >
      <div class="success-icon-box mb-4">
        <i class="fas fa-check-circle icon-succes text-success"></i>
      </div>
      <h4 class="alert-heading fw-bold text-success">
        Bài viết đã được gửi thành công!
      </h4>
      <p class="mb-4 alert-content px-lg-5">
        Cảm ơn bạn đã đóng góp nội dung. Bài viết sẽ được quản trị viên kiểm
        duyệt và đăng tải sớm nhất. Vui lòng chờ đợi trong giây lát!
      </p>

      <div class="d-flex justify-content-center gap-3 mt-4 pt-2">
        <ButtonCore
          text="Trở về Trang chủ"
          variantClass="btn-outline-core"
          :handleClick="() => closeModal()"
          :customStyle="{
            height: '40px',
            width: '160px',
            padding: '5px 10px',
          }"
        />
        <ButtonCore
          text="Tiếp tục đăng bài"
          variantClass="btn-success-core"
          :handleClick="handleResetToNew"
          :customStyle="{
            height: '40px',
            width: '160px',
            padding: '5px 10px',
          }"
        />
      </div>
    </div>

    <b-modal
      v-model="showCropperModal"
      title="Cắt ảnh theo tỉ lệ (3:2)"
      size="lg"
      centered
      no-close-on-backdrop
      hide-header-close
      hide-footer
      hide-header
      @shown="handleCropperModalShown"
      @hidden="handleCropperModalHidden"
    >
      <div class="d-flex justify-content-end border-bottom pb-2 w-100">
        <ButtonCore
          text="Hủy"
          variantClass="btn-close-core"
          :handleClick="cancelCrop"
          :customStyle="{ width: '70px', margin: '0 5px' }"
          :isDisable="isUploadingFile || isDisableButton"
        />
        <ButtonCore
          :text="isUploadingFile ? 'Đang tải lên...' : 'Lưu'"
          variantClass="btn-accept-core"
          iconClass="fas fa-crop-alt"
          :handleClick="cropAndUpload"
          :customStyle="{ width: '70px' }"
          :isDisable="isUploadingFile || isDisableButton"
        />
      </div>
      <div class="cropper-container">
        <p class="text-muted small mb-2 mt-2">
          Vui lòng điều chỉnh khung để lấy phần ảnh đẹp nhất
        </p>
        <div class="image-cropper-area shadow-inner rounded overflow-hidden">
          <Cropper
            v-if="isCropperVisible"
            ref="cropper"
            :src="rawImageUrl"
            :stencil-props="{ aspectRatio: 3 / 2 }"
            :resize-image="{ adjustStencil: false }"
            :transitions="true"
            class="upload-cropper"
          />
        </div>
      </div>

      <!-- <template #modal-header>
         
        </template> -->
    </b-modal>
  </b-modal>
</template>

<script>
import axios from "axios";
import { tinTucModel } from "@/models/profession/tinTuc/tinTucModel";

import { ValidationObserver, ValidationProvider } from "vee-validate";
import { tinTucValidator } from "@/models/profession/tinTuc/tinTucValidator";
// import ImageFileCropperUploader from "./ImageFileCropperUploader.vue";

import { ButtonCore } from "@/components/widgets";
// import { ImageCroper } from "./imageFileCropperUploader.vue";
import { Cropper } from "vue-advanced-cropper";
import "vue-advanced-cropper/dist/style.css";

export default {
  components: {
    ButtonCore,
    ValidationObserver,
    ValidationProvider,
    Cropper,
  },
  name: "FormCreateFeed",
  data() {
    return {
      isSubmitting: false,
      selectedFile: null,
      isSubmittedSuccess: false,
      isDisableButton: false,
      isUploadingFile: false, // NEW: Trạng thái tải file

      // NEW: State cho Cropping
      showCropperModal: false,
      isCropperVisible: false,
      rawFile: null, // File gốc
      rawImageUrl: null, // URL Base64/Blob của ảnh đã resize (Được dùng làm source cho Cropper)

      tinTucValidator,
      form: {
        nameAuthor: "",
        content: "",
        describe: "", // Thêm trường describe để phù hợp với template
        // Đây là cấu trúc dữ liệu dự kiến sau khi xử lý file upload
        fileImage: {
          fileId: null,
          ext: null,
          path: null,
        },
      },

      url: `${process.env.VUE_APP_API_URL}filesminio/view/`,
      showImageModal: false,
      currentImageSrc: "",

      maxDescribeLength: 500, // Định nghĩa giới hạn

      // Khởi tạo model trống cho lần đầu
      initialForm: {
        nameAuthor: "",
        content: "",
        describe: "",
        fileImage: { fileId: null, ext: null, path: null },
      },
    };
  },
  watch: {
    // Theo dõi file được chọn và reset nếu cần
    selectedFile(newFile) {
      if (!newFile) {
        this.form.fileImage = this.initialForm.fileImage;
      }
    },
    // NEW: Computed property cho URL preview ảnh nhỏ
    previewImageUrl() {
      return this.form.fileImage.fileId
        ? this.url + this.form.fileImage.fileId
        : null;
    },
  },
  computed: {
    // Tính toán số ký tự cho Nội dung
    describeCharacterCount() {
      // Dùng form.describe vì đây là trường được bind trong template
      return this.form.describe ? this.form.describe.length : 0;
    },
  },

  methods: {
    async handlePost() {
      this.isSubmitting = true;
      try {
        if (
          !this.$refs.providerFileImage.errors.length &&
          !this.form.fileImage?.fileId
        ) {
          await this.$store.dispatch("snackBarStore/addNotify", {
            data: {
              code: "WARNING",
              message: "Vui lòng chọn ảnh cho bài viết",
            },
          });
          return;
        }

        this.isLoading = true;

        let loader = this.$loading.show({
          container: this.$refs.formContainer,
        });

        const res = await this.$store.dispatch(
          "profession/tinTuc/tinTucStore/create",
          tinTucModel.toJson(this.form)
        );

        if (res.code === 0) {
          // Hiển thị thông báo thành công trong modal
          this.isSubmittedSuccess = true;
          this.isDisableButton = true;

          // await this.$store.dispatch("snackBarStore/addNotify", {
          //   data: {
          //     code: res.code,
          //     message: "Bài viết đã được gửi thành công!",
          //   },
          // });
          // Gọi hàm đóng modal, hàm này sẽ trì hoãn việc đóng
          // this.closeModal();
        } else {
          this.$store.dispatch("snackBarStore/addNotify", {
            data: {
              code: res.code,
              message: res.message,
            },
          });
        }

        loader.hide();
        this.submitted = false;
      } catch (err) {
        console.error("Submission error:", err);
        this.$store.dispatch("snackBarStore/addNotify", {
          data: {
            code: -1,
            message: "Có lỗi xảy ra trong quá trình đăng bài.",
          },
        });
      } finally {
        this.isSubmitting = false;
      }
    },

    // resizeImage(file) {
    //   return new Promise((resolve) => {
    //     const reader = new FileReader();
    //     reader.onload = (readerEvent) => {
    //       const img = new Image();
    //       img.onload = () => {
    //         const MAX_WIDTH = 1500; // Giới hạn chiều rộng tối đa 1500px
    //         const MAX_HEIGHT = 1000; // Giới hạn chiều cao tối đa 1000px
    //         let width = img.width;
    //         let height = img.height;
    //         let ratio = width / height;

    //         if (width > MAX_WIDTH || height > MAX_HEIGHT) {
    //           if (width > height) {
    //             height = MAX_WIDTH / ratio;
    //             width = MAX_WIDTH;
    //           } else {
    //             width = MAX_HEIGHT * ratio;
    //             height = MAX_HEIGHT;
    //           }
    //         }

    //         const canvas = document.createElement("canvas");
    //         canvas.width = width;
    //         canvas.height = height;
    //         const ctx = canvas.getContext("2d");

    //         // Vẽ ảnh đã resize lên canvas
    //         ctx.drawImage(img, 0, 0, width, height);

    //         // Chuyển Canvas thành Data URL (Base64) với chất lượng nén 0.8 (JPEG)
    //         const resizedDataUrl = canvas.toDataURL("image/jpeg", 0.8);

    //         resolve(resizedDataUrl);
    //       };
    //       img.src = readerEvent.target.result;
    //     };
    //     reader.readAsDataURL(file);
    //   });
    // },
    // BƯỚC 1: Kích hoạt input file ẩn
    triggerFileUpload() {
      this.$refs.fileUploader.click();
    },

    async handleFileChange(event) {
      const file = event.target?.files?.[0];
      if (!file || !file.type.startsWith("image/")) return;

      // GIỚI HẠN FILE ẢNH DƯỚI 40MB
      const maxSize = 40 * 1024 * 1024;
      if (file.size > maxSize) {
        this.$store.dispatch("snackBarStore/addNotify", {
          data: {
            code: -1,
            message:
              "Kích thước ảnh không được vượt quá 40MB. Vui lòng chọn ảnh nhỏ hơn.",
          },
        });
        event.target.value = "";
        return;
      }

      this.rawFile = file;

      // Đọc file trực tiếp để đưa vào Cropper mà không Resize
      const reader = new FileReader();
      reader.onload = (e) => {
        this.rawImageUrl = e.target.result;
        this.showCropperModal = true;
      };
      reader.readAsDataURL(file);

      event.target.value = "";
    },
    // BƯỚC 3: Hàm xử lý khi Cropper Modal MỞ XONG
    handleCropperModalShown() {
      // QUAN TRỌNG: Dùng $nextTick để mount Cropper SAU KHI DOM đã ổn định
      this.$nextTick(() => {
        this.isCropperVisible = true;
      });
    },
    // BƯỚC 4: Hàm xử lý khi Cropper Modal ĐÓNG
    handleCropperModalHidden() {
      this.isCropperVisible = false;
      this.rawFile = null;
      this.rawImageUrl = null;
    },

    // BƯỚC 5: Hàm hủy crop (gọi từ nút Hủy)
    cancelCrop() {
      this.showCropperModal = false; // Đóng modal, logic reset file chạy ở handleCropperModalHidden
    },

    // BƯỚC 6: HÀM XỬ LÝ CROP VÀ UPLOAD
    cropAndUpload() {
      if (!this.$refs.cropper) return;

      const { canvas } = this.$refs.cropper.getResult();
      if (!canvas) return;

      // Đặt trạng thái loading ngay lập tức
      this.isUploadingFile = true;

      // Xóa ảnh cũ trước khi upload ảnh mới
      if (this.form.fileImage.fileId) {
        this.deleteFileOnServer(this.form.fileImage.fileId, false);
      }

      // Chuyển canvas thành Blob để gửi đi như một file
      canvas.toBlob(
        async (blob) => {
          this.showCropperModal = false; // Đóng cropper

          const formData = new FormData();
          const originalFileName = this.rawFile.name;
          const fileExt = originalFileName.split(".").pop() || "jpg";
          const fileNameWithExt =
            originalFileName.replace(/\.[^/.]+$/, "") + `_cropped.${fileExt}`;

          formData.append("files", blob, fileNameWithExt);

          try {
            const response = await axios.post(
              `${process.env.VUE_APP_API_URL}filesminio/Upload`,
              formData
            );

            if (response.data.code === 0 && response.data.data?.fileId) {
              this.form.fileImage = {
                fileId: response.data.data.fileId,
                fileName: response.data.data.fileName,
                ext: fileExt,
                path: response.data.data.path,
              };
              this.$refs.providerFileImage.validate();
              // this.$store.dispatch("snackBarStore/addNotify", {
              //   data: { message: "Ảnh đã được cắt và lưu!", code: 0 },
              // });
            } else {
              this.$store.dispatch("snackBarStore/addNotify", {
                data: {
                  message: response.data.message || "Tải ảnh thất bại!",
                  code: -1,
                },
              });
            }
          } catch (error) {
            this.$store.dispatch("snackBarStore/addNotify", {
              data: { message: "Đã xảy ra lỗi khi tải ảnh.", code: -1 },
            });
          } finally {
            this.isUploadingFile = false; // Reset loading state
          }
        },
        "image/jpeg",
        0.9
      );
    },

    // BƯỚC 7: XÓA ẢNH (Click nút Xóa trên preview)
    async handleDeleteFile() {
      if (!confirm("Bạn có chắc chắn muốn xóa ảnh này không?")) return;

      const fileId = this.form.fileImage.fileId;
      if (!fileId) return;

      const success = await this.deleteFileOnServer(fileId, true);

      if (success) {
        this.form.fileImage = { fileId: null, ext: null, path: null };
        this.$refs.providerFileImage.validate(); // Kích hoạt validation lại
      }
    },
    handleResetToNew() {
      this.isSubmittedSuccess = false;
      this.resetForm();
    },
    // Hàm xóa file trên server (Được gọi khi đóng modal hoặc xóa ảnh)
    async deleteFileOnServer(fileId, isNotify = true) {
      try {
        await axios
          .post(`${process.env.VUE_APP_API_URL}filesminio/delete/${fileId}`)
          .then((res) => {
            if (res.data.code === 0) {
              this.form.fileImage = { fileId: null, ext: null, path: null };
              this.$refs.providerFileImage.validate(); // Kích hoạt validation lại
              // if (isNotify) {
              //   this.$store.dispatch("snackBarStore/addNotify", {
              //     data: { message: "Xóa file thành công!", code: 0 },
              //   });
              // }
            }
          });

        return true;
      } catch (e) {
        console.error("Lỗi xóa file:", e);
        if (isNotify) {
          this.$store.dispatch("snackBarStore/addNotify", {
            data: { message: "Lỗi khi xoá file trên server.", code: -1 },
          });
        }
        return false;
      }
    },

    closeModal() {
      // Logic xóa file cũ khi đóng nếu chưa submitted
      if (this.form.fileImage?.fileId && !this.isSubmittedSuccess) {
        this.deleteFileOnServer(this.form.fileImage.fileId, false);
      }

      this.$bvModal.hide("create-news-modal");
      this.resetForm();
    },

    resetForm() {
      this.form = Object.assign({}, this.initialForm);
      this.selectedFile = null;
      this.isSubmitting = false;
      this.isSubmittedSuccess = false;
      this.isDisableButton = false;
      this.isUploadingFile = false;
      if (this.$refs.observer) {
        this.$refs.observer.reset();
      }
    },
  },
  created() {
    this.initialForm = Object.assign({}, this.form);
  },
};
</script>

<style scoped>
/* ======================================= */
/* STYLE CHỦ ĐỀ FESTIVAL HOA */

/* NEW STYLE CHO FILE UPLOADER */
.file-cropper-area {
  min-height: 40px; /* Đảm bảo khu vực này hiển thị được nút */
}
.image-preview-container {
  margin-top: 10px;
  position: relative;
  display: block; /* Quan trọng để chiếm dòng riêng */
  max-width: 250px;
  border-radius: 8px;
  overflow: hidden;
}
.current-file-image {
  max-width: 100%;
  height: auto;
  max-height: 200px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transition: all 0.3s;
  cursor: pointer;
}
.current-file-image:hover {
  opacity: 0.9;
}

.btn-select-file {
  padding: 8px 15px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 6px;
  font-weight: 500;
  transition: all 0.2s;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.btn-select-file:hover {
  background-color: #0056b3;
}

.btn-delete-file {
  position: absolute;
  top: 5px;
  right: 5px;
  background-color: #dc3545;
  color: white;
  border: none;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  font-size: 0.8rem;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  opacity: 0.8;
  transition: opacity 0.2s;
  cursor: pointer;
}
.btn-delete-file:hover {
  opacity: 1;
}

.upload-cropper {
  max-height: 400px; /* Giới hạn chiều cao Cropper trong modal */
  width: 100%;
}

/* --- MODAL DECORATED (ÁP DỤNG LẠI TỪ CAROUSEL) --- */
::v-deep .flower-modal-decorated .modal-content {
  border-radius: 20px;
  border: 3px solid var(--color-primary, --color-primary-dark); /* Viền màu xanh lá */
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
  background: linear-gradient(110deg, #f7fcf7, #fbf2f2); /* Nền gradient nhẹ */
}

/* Custom Title Class */
::v-deep .flower-title-decorated {
  font-size: 1.4rem;
  font-weight: 800;
  color: var(--color-primary-dark, #082957);
  /* Thay đổi nền header để nổi bật hơn */
  background: transparent !important;
  border-bottom: 2px solid var(--color-primary);
  padding: 1rem 1.5rem;
}
/* Ẩn header mặc định và áp dụng style lên title-class (chỉ khi cần thiết) */
::v-deep .flower-modal-decorated .modal-header {
  background: none;
  border-bottom: none;
  padding-bottom: 0;
}
/* Input Fields và Textarea */
.flower-input {
  border-radius: 8px;
  border: 1px solid var(--color-gray);
  transition: all 0.3s ease;
  padding: 10px 15px;
  height: auto;
}

.flower-input:focus {
  border-color: var(--color-secondary); /* Border xanh lá khi focus */
  /* box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.25); */
}

.form-label {
  font-weight: 600;
  color: var(--color-dark);
  margin-bottom: 0.25rem;
}

/* Các trường yêu cầu (required) */
.required-star {
  color: var(--color-danger); /* Màu đỏ nổi bật */
  font-weight: 500;
}

.character-count {
  color: var(--color-gray);
  font-size: 0.8rem;
}

/* Footer (Nút hành động) */
.flower-footer-actions {
  border-top: 1px dashed var(--color-gray);
}

/* Tùy chỉnh Validation (Is-Invalid) */
.is-invalid {
  border-color: var(--color-danger) !important;
}

/* Căn chỉnh ảnh đại diện */

/* Style cho Alert Box mới */
.flower-alert {
  background-color: #e6f7e6; /* Nền xanh lá nhạt */
  border-color: #b7e0b7;
  color: var(--color-secondary);
  border-radius: 8px;
  margin-top: 10px;
}

.flower-alert .alert-heading {
  color: var(--color-secondary);
}

.upload-cropper {
  max-height: 400px; /* Giới hạn chiều cao Cropper trong modal */
  width: 100%;
}

/* ======================================== */
/* SUCCESS STATE STYLES */
/* ======================================== */
.success-result-wrapper {
  animation-duration: 0.8s;
}

.alert-heading {
  font-size: 1.3rem;
}
.alert-content {
  font-size: 1.1rem;
}

.success-icon-box i {
  filter: drop-shadow(0 4px 10px rgba(40, 167, 69, 0.3));
}
.icon-succes {
  font-size: 4.5rem;
}

/* RESPONSIVE */
@media (min-width: 376px) and (max-width: 580px) {
  .form-container-wrapper {
    padding: 20px;
  }
  .logo-festival {
    width: 160px;
    height: auto;
  }

  .icon-succes {
    font-size: 4.2rem;
  }

  .page-title {
    font-size: 1.1rem;
  }
  .flower-input {
    border-radius: 8px;
    border: 1px solid var(--color-gray, #ccc);
    padding: 8px 10px;
  }
  .image-preview-container {
    margin-top: 5px;
    position: relative;
    display: block;
    max-width: 185px;
    border-radius: 8px;
    overflow: hidden;
  }

  .alert-heading {
    font-size: 1.2rem;
  }
  .alert-content {
    font-size: 0.9rem;
  }
}

@media (max-width: 375px) {
  .form-container-wrapper {
    padding: 20px;
  }
  .logo-festival {
    width: 150px;
    height: auto;
  }
  .logo-festival-wrapper {
    text-align: center;
    margin-bottom: 5px;
  }

  .page-title {
    font-size: 1.1rem;
  }
  .flower-input {
    border-radius: 8px;
    border: 1px solid var(--color-gray, #ccc);
    padding: 6px 7px;
  }
  .image-preview-container {
    margin-top: 3px;
    position: relative;
    display: block;
    max-width: 160px;
    border-radius: 8px;
    overflow: hidden;
  }

  .icon-succes {
    font-size: 4rem;
  }

  .alert-heading {
    font-size: 1.1rem;
  }
  .alert-content {
    font-size: 0.9rem;
  }
}
</style>
